var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocketIo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 256,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 256",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m96.4465116 7.38232558c32.2679074-8.27534884 67.9293024-3.45302325 96.3869764 14.10976742 35.84 21.4325582 59.23721 61.975814 59.832559 103.709767 1.309767 42.150698-20.658605 83.944187-55.962791 106.865117-39.293023 26.433488-93.648372 27.445581-133.7748839 2.32186-40.9004651-24.409302-64.7739535-73.644651-58.64186047-120.915349 4.94139535-49.9497671 43.51999997-94.005581 92.15999997-106.09116242z",
    fill: "#010101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m91.5051163 27.8027907c60.9637207-24.40930233 135.7395347 20.6586046 142.0502327 86.0279073 9.823256 58.820465-38.995349 118.593488-98.589768 120.32-56.6772089 5.655814-111.4493019-42.388838-113.0567438-99.304186-4.2269767-46.0800004 26.135814-91.8027911 69.5962791-107.0437213z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#010101"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m97.6372093 121.689302c27.3265117-22.3255811 54.0576747-45.425116 81.9795347-67.0958136-14.645581 22.504186-29.707907 44.7106976-44.353488 67.2148836-12.561861.059535-25.123721.059535-37.6260467-.11907z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.736744 134.132093c12.621396 0 25.183256 0 37.745116.178605-27.505116 22.206511-54.117209 45.484651-82.0986042 67.095814 14.6455814-22.504186 29.7079072-44.770233 44.3534882-67.274419z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocketIo);
export default __webpack_public_path__ + "static/media/socket-io.b8720a3bcb9f85168e0767bd3a3d3d27.svg";
export { ForwardRef as ReactComponent };